import React, { useState } from 'react';
import { HelpCircle, ChevronRight, X } from 'lucide-react';

const FabricGuide = () => {
    const [activeGuide, setActiveGuide] = useState(null);

    const guides = [
        {
            title: "What is Superpoly Fabric?",
            excerpt: "Superpoly is a specialized polyester knit fabric featuring a smooth, semi-shiny outer surface...",
            description: "Superpoly is a specialized polyester knit fabric featuring a smooth, semi-shiny outer surface and a soft, brushed inner for maximum comfort. It is the preferred choice for tracksuits, athletic jackets, and school uniforms across Madhya Pradesh due to its exceptional durability, color retention, and wrinkle-resistant properties. Its unique construction allows for excellent breathability while providing sufficient warmth for athletic applications.",
            kw: "superpoly fabric uses jabalpur"
        },
        {
            title: "2-Way vs 4-Way Stretch",
            excerpt: "Understand the difference between 2-Way and 4-Way Zurich fabrics. 4-way offers 360-degree flexibility...",
            description: "2-way stretch fabrics expand in one direction (usually widthwise), offering basic comfort at a competitive price. 4-way stretch, such as our premium Zurich Lycra, expands both horizontally and vertically, providing 360-degree mobility. For high-performance gym wear, yoga pants, and professional sportswear, 4-way stretch is the industry benchmark for fit, comfort, and fabric recovery after intense physical activity.",
            kw: "difference between 2 way and 4 way lycra"
        },
        {
            title: "Choosing the Right GSM",
            excerpt: "GSM (Grams per Square Meter) is the standard measure of fabric density and thickness...",
            description: "GSM (Grams per Square Meter) is the standard measure of fabric density and thickness. Selecting the correct weight is vital for product quality: 160-180 GSM is ideal for lightweight t-shirts, while 220-280 GSM is required for premium lowers, tracksuits, and winter sportswear. We help manufacturers in MP and Jabalpur select the exact density needed for their specific target market, ensuring the perfect balance between comfort and durability.",
            kw: "understanding fabric gsm for manufacturing"
        }
    ];

    return (
        <section id="guide" className="py-16 bg-white border-t border-gray-100">
            <div className="container mx-auto px-4">
                {/* Header */}
                <div className="text-center mb-12">
                    <div className="max-w-2xl mx-auto">
                        <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-4 flex items-center justify-center gap-3">
                            <HelpCircle className="text-primary" size={32} />
                            Fabric Buying <span className="text-primary">Guide</span>
                        </h2>
                        <p className="text-gray-600 text-lg">
                            Expert technical advice to help you choose the best materials for your garment business.
                        </p>
                    </div>
                </div>

                {/* Grid */}
                <div className="grid md:grid-cols-3 gap-8">
                    {guides.map((guide, index) => (
                        <div key={index} className="p-8 rounded-2xl bg-gray-50 border border-gray-100 shadow-sm flex flex-col h-full hover:shadow-md transition-shadow">
                            <h3 className="text-xl font-bold text-gray-900 mb-4 text-primary">
                                {guide.title}
                            </h3>
                            <p className="text-gray-600 text-sm leading-relaxed mb-6 flex-grow">
                                {guide.excerpt}
                            </p>
                            <button
                                onClick={() => setActiveGuide(guide)}
                                className="flex items-center text-primary font-bold text-sm hover:gap-2 transition-all group"
                            >
                                Read Full Guide <ChevronRight size={16} className="ml-1 group-hover:ml-2 transition-all" />
                            </button>
                            <span className="sr-only">{guide.kw}</span>
                        </div>
                    ))}
                </div>

                {/* Footer CTA */}
                <div className="mt-12 p-6 bg-gray-900 rounded-2xl text-white text-center">
                    <p className="text-lg">Need custom fabric advice? <span className="text-accent font-bold">Contact Arihant Sales Jabalpur</span> for a free consultation.</p>
                </div>

                {/* Technical Description Modal */}
                {activeGuide && (
                    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
                        <div className="bg-white rounded-3xl max-w-2xl w-full p-8 lg:p-12 relative shadow-2xl animate-in zoom-in-95 duration-200">
                            <button
                                onClick={() => setActiveGuide(null)}
                                className="absolute top-6 right-6 p-2 rounded-full hover:bg-gray-100 text-gray-500 transition-colors"
                            >
                                <X size={24} />
                            </button>

                            <div className="flex items-center gap-4 mb-6">
                                <div className="w-12 h-12 bg-primary/10 rounded-2xl flex items-center justify-center text-primary">
                                    <HelpCircle size={28} />
                                </div>
                                <h3 className="text-2xl lg:text-3xl font-bold text-gray-900">
                                    {activeGuide.title}
                                </h3>
                            </div>

                            <div className="prose prose-teal max-w-none">
                                <p className="text-gray-700 text-lg leading-relaxed">
                                    {activeGuide.description}
                                </p>
                            </div>

                            <div className="mt-10 pt-8 border-t border-gray-100 flex flex-col sm:flex-row items-center justify-between gap-4">
                                <p className="text-gray-500 text-sm italic">Expert insight by Arihant Sales Jabalpur</p>
                                <button
                                    onClick={() => setActiveGuide(null)}
                                    className="btn-primary px-8 py-3 rounded-full w-full sm:w-auto"
                                >
                                    Got it, thanks!
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </section>
    );
};

export default FabricGuide;
